import {HtmlTekst} from "../tjenester/ressurser/generertNg2HttpKlient";
import {erTomEllerNil} from "./strenger";
import {nil} from "felles-ng2/typer/nullish";

/** Returnerer sann dersom angitt html-formatert tekst er tom.
 * Teksten anses som tom dersom den kun inneholder html-tagger uten tekst eller kun blanke tegn, eller dersom angitt tekst er nil */
export function erTomHtmlTekst(tekst: HtmlTekst | nil): boolean {
    if (erTomEllerNil(tekst)) return true;
    const tekstUtenTagger = tekst
      // Fjern alle HTML-tagger
      .replace(/<[^>]*>/g, '')
      //fjerner enkodet mellomrom
      .replace(/&nbsp;/gi, ' ')
      .trim();

    return tekstUtenTagger.length === 0;
}
